import { Tooltip } from "antd";

export const ROC_CONFIDENTIALITY_STATEMENT =
	"STATEMENT OF CONFIDENTIALITY: The information contained in this and any attached pages is intended to be for the use of the addressee named in this transmittal sheet. If you are not the addressee, note that any disclosure, photocopying distribution or use of the contents of this faxed information is prohibited. If you have received this facsimile in error, please notify us by telephone (collect) immediately so that we can arrange for the retrieval of the original documents at no cost to you.";

const ConfidentialityStatement = () => {
	return (
		<div style={{ fontSize: "10px", width: "100%" }}>
			<Tooltip title={ROC_CONFIDENTIALITY_STATEMENT}>{ROC_CONFIDENTIALITY_STATEMENT}</Tooltip>
		</div>
	);
};

export default ConfidentialityStatement;
